import React from 'react'
import styled from '@emotion/styled'
import { Grid, GridProps } from '@mui/material'

const StyledGrid = styled(Grid)({
  display: 'flex',
  alignItems: 'center'
})

const HorizontalStackGrid = (props: GridProps) => {
  const { children, ...otherProps } = props
  return (
    <StyledGrid item {...otherProps}>
      {children}
    </StyledGrid>
  )
}

export default HorizontalStackGrid
